require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-luigi-colombi.json") })
        }
      }, "path---en-interviste-luigi-colombi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-luigi-colombi!./.cache/json/en-interviste-luigi-colombi.json
// module id = 588
// module chunks = 231608221292675